/* Deprecated - please use app/assets/javascripts/react/shared/components/DesignSystem/Button/index.jsx */

import classNames from 'classnames';
import PropTypes from 'prop-types';

import style from './index.module.scss';

const Button = ({
  children,
  onClick,
  className,
  type,
  full = false,
  small = false,
  purpose,
  disabled = false,
  id,
  testid,
}) => (
  <button
    className={classNames(className, style.component, {
      [style[`component--${purpose}`]]: !!purpose,
      [style['component--full']]: full,
      [style['component--small']]: small,
    })}
    onClick={onClick}
    disabled={disabled}
    id={id}
    // eslint-disable-next-line react/button-has-type
    type={type}
    data-testid={testid}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  purpose: PropTypes.oneOf(['primary', 'secondary', 'delete', 'cancel']),
  full: PropTypes.bool,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  testid: PropTypes.string,
};

export default Button;
